module.exports = __webpack_public_path__ + "img/CATEGORY ICON-20.4a32fe39.png";